import { z } from "zod";
import { PostalAddressSchema } from "./PostalAddress";
import { WorkflowSchema } from "./Workflow";

export const PracticalExamWorkflowSchema = WorkflowSchema.extend({
  type: z.literal("practicalExamSignUp"),
  workflowData: z.object({
    studentUid: z.string().nonempty(),
    bookedTrainingId: z.string().nonempty(),
    assignedInstructorUid: z.string().nonempty(),
    examLocation: z.object({
      uid: z.string().nonempty(),
      name: z.string(),
      postalAddress: PostalAddressSchema,
    }),
    preferredDates: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)).min(1),
    preferredTimeOfDay: z.array(z.enum(["morning", "afternoon"])).min(1),
  }),
});
export type PracticalExamWorkflow = z.infer<typeof PracticalExamWorkflowSchema> & { id: string };
